type PaginationParams = { page: number };

type PaginatedRequestArgs = PaginationParams & { userId: string };

type PaginatedApiResponse<K extends string, T> = {
	receivedCount: number;
	totalLength: number;
	totalPages?: number;
} & {
	[P in K]: T[];
};

type DataType = { id: number } | { uid: string };

export const getPaginationByPageParams = <K extends string, T extends DataType>(
	dataKey: K,
	prepare?: (data: T[]) => T[]
) => ({
	transformResponse: (
		response: PaginatedApiResponse<K, T> | null
	): PaginatedApiResponse<K, T> => {
		if (response === null) {
			return {
				receivedCount: 0,
				totalLength: 0,
				totalPages: 0,
				[dataKey]: [],
			} as PaginatedApiResponse<K, T>;
		}

		const data = prepare ? prepare?.(response[dataKey]) : response[dataKey];

		return {
			[dataKey]: data,
			receivedCount: data.length,
			totalLength: data.length,
			totalPages: response.totalPages,
		} as PaginatedApiResponse<K, T>;
	},

	serializeQueryArgs: ({
		endpointName,
		queryArgs,
	}: {
		endpointName: string;
		queryArgs: PaginatedRequestArgs;
	}) => {
		if (typeof queryArgs !== 'object') {
			return '';
		}

		return [endpointName, 'userId' in queryArgs ? queryArgs.userId : null]
			.filter(Boolean)
			.join('-');
	},

	forceRefetch: ({
		currentArg,
		previousArg,
	}: {
		currentArg: PaginatedRequestArgs | undefined;
		previousArg: PaginatedRequestArgs | undefined;
	}) => {
		return (currentArg?.page ?? 1) !== (previousArg?.page ?? 1);
	},
});
